import React from "react"
import { BlockRow } from "./Block"
import { DeleteButton } from "./DeleteButton"
import { ShipDataItem } from "./ShipDataItem"

interface ShipSingleRowDataItemProps {
  namePrefix: string;
  id?: string | number;
  rowClassName?: string;
  onRemove?: () => void;
  children: React.ReactNode;
}

export function ShipSingleRowDataItem({ namePrefix, id, rowClassName, onRemove, children }: ShipSingleRowDataItemProps) {
  return (
    <ShipDataItem namePrefix={namePrefix} id={id}>
      <BlockRow className={rowClassName}>
        {children}
        {onRemove && <DeleteButton onClick={onRemove} />}
      </BlockRow>
    </ShipDataItem>
  );
}
